import React from "react"
import mainWrapper from "../assets/images/main-wraper-bg-mob.png"
import element2Mob from "../assets/images/element_2_mob.png"
import element3Mob from "../assets/images/element_3_mob.png"
import iconAwesomeCheck from "../assets/images/Icon-awesome-check.png"
import mainGraphic from "../assets/images/main-graphic.png"
import element2 from "../assets/images/element-2.svg"
import { useSpring, animated } from "react-spring"

const calc = (x, y) => [
  -(y - window.innerHeight / 2) / 20,
  (x - window.innerWidth / 2) / 20,
  1.1,
]
const trans = (x, y, s) =>
  `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`

const Lock = () => {
  const [props, set] = useSpring(() => ({
    xys: [0, 0, 1],
    config: { mass: 5, tension: 350, friction: 100 },
  }))
  return (
    <>
      <div
        className="position-relative"
        onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
        onMouseLeave={() => set({ xys: [0, 0, 1] })}
        aria-hidden="true"
      >
        <div className="container">
          <div className="row position-relative">
            <div className="col-12 d-lg-none d-flex mob-imgs">
              <img
                src={mainWrapper}
                className="mx-auto mobile-wraper-img-1"
                data-aos="fade-left"
                height="300px"
                width="250px"
                alt="moving out should be simple"
              />
            </div>
            <div className="col-lg-7 padding-top position-relative">
              <h1 className="main-heading-main large page-heading change-txt">
                Because moving out should be simple.
              </h1>
              <img
                src={element3Mob}
                className="img-fluid elemant-3-img"
                alt="Undorm right background"
              />
              <div className="row mt-3 position-relative">
                <div className="col-md-3 col-2">
                  <hr className="text-hr" />
                </div>
                <div className="col-md-9 col-10">
                  <p className="main-wraper-sub-heading">It should be...</p>
                  <h3 className="shoud-be-item mb-1">
                    <img
                      src={iconAwesomeCheck}
                      className="img-fluid mr-2"
                      alt="Undorm icon"
                    />
                    Fun
                  </h3>
                  <h3 className="shoud-be-item mb-1">
                    <img
                      src={iconAwesomeCheck}
                      className="img-fluid mr-2"
                      alt="Undorm icon"
                    />
                    Convenient
                  </h3>
                  <h3 className="shoud-be-item mb-1">
                    <img
                      src={iconAwesomeCheck}
                      className="img-fluid mr-2"
                      alt="Undorm icon"
                    />
                    On Your Terms
                  </h3>
                  <p
                    className="main-wraper-sub-heading free"
                    style={{ fontSize: 20 }}
                  >
                    <br />
                    and your interests should always be put first.
                  </p>
                  <div className="black-line" />
                </div>
                <img
                  src={element2Mob}
                  className="img-fluid elemant-2-img"
                  alt="Undorm left background"
                />
              </div>
            </div>
            <div className="col-lg-5 d-lg-block d-none">
              <div className="hero-square hero-square-4 is-moving-object is-rotating">
                <animated.div
                  style={{ transform: props.xys.interpolate(trans) }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="lock-img"
                    viewBox="0 0 317.85 670.592"
                  >
                    <g
                      id="keyhole"
                      transform="matrix(0.982, 0, 0.02, 0.995, -180.266, -58.979)"
                    >
                      <circle
                        id="Ellipse_4"
                        data-name="Ellipse 4"
                        cx="157.235"
                        cy="157.235"
                        r="157.235"
                        transform="translate(182 58)"
                        fill="#009dff"
                      />
                      <path
                        id="Path_140"
                        data-name="Path 140"
                        d="M19574.762-5134.946,19418.02-4551.7h309.793Z"
                        transform="translate(-19235.525 5257.53)"
                        fill="#009dff"
                      />
                    </g>
                  </svg>
                </animated.div>
              </div>
              <img
                src={mainGraphic}
                className="img-fluid main-wraper-right-img d-inline d-lg-none"
                alt="main wraper right background"
              />
              <img
                src={mainGraphic}
                className="img-fluid main-wraper-right-img d-lg-inline d-none"
                alt="main wraper"
              />
            </div>
          </div>
        </div>
        <img
          src={element2}
          className="img-fluid main-wraperp-img-1 d-lg-inline d-none"
          alt="left backgorund"
        />
      </div>
    </>
  )
}

export default Lock
